module.exports = __webpack_public_path__ + "img/xinyongpinggushouquan.52c9c5c4.png";